import { render, staticRenderFns } from "./PixInfractions_Defense.vue?vue&type=template&id=6fdf3350&scoped=true"
import script from "./PixInfractions_Defense.vue?vue&type=script&lang=ts"
export * from "./PixInfractions_Defense.vue?vue&type=script&lang=ts"
import style0 from "./PixInfractions_Defense.vue?vue&type=style&index=0&id=6fdf3350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdf3350",
  null
  
)

export default component.exports